import { render, staticRenderFns } from "./DisplayErrorMessages.vue?vue&type=template&id=0a13b7b5"
import script from "./DisplayErrorMessages.vue?vue&type=script&lang=js"
export * from "./DisplayErrorMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports